// Template Generated by DataExtraction.py at 1721092908

import DualLicenseDisclosureEn1 from "../../Forms/Dual License Disclosure/DualLicenseDisclosure_En1.png";
import DualLicenseDisclosureEn1Labels from "../../Labels/Dual License Disclosure/DualLicenseDisclosure_En1.json";
import DualLicenseDisclosureFr1 from "../../Forms/Dual License Disclosure/DualLicenseDisclosure_Fr1.png";
import DualLicenseDisclosureFr1Labels from "../../Labels/Dual License Disclosure/DualLicenseDisclosure_Fr1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authenticationStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? DualLicenseDisclosureFr1Labels : DualLicenseDisclosureEn1Labels;
    const formImage = isFrench ? DualLicenseDisclosureFr1 : DualLicenseDisclosureEn1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    // Drawing the form
    // TODO implement fields

    if (!authenticationStatus) {
        return;
    }

    if (!authenticationStatus.user) {
        return;
    }

    const agent = authenticationStatus.user.agentCodes.find((ac) => ac.code === data.common.agentCode);

    if (!agent) {
        return;
    }


    drawText(agent.dualLicenseText, "dualLicenseText");
    //drawText("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore", "dualLicenseText")
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? DualLicenseDisclosureFr1Labels : DualLicenseDisclosureEn1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];



    return signers;
}

export default {
    generate,
    signatureDefinitions
}
